import { useEffect, useState } from 'react';
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Autocomplete, CircularProgress, Box, Tooltip, Typography } from '@mui/material';
import { AttachementsUpload } from '../../../../shared_elements/components';
import { useParams } from 'react-router-dom';
import { addEolObligationApi, editEolObligationApi } from '../apiServices';
import { checkApiStatus } from '../../../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { regexConstants } from '../../../../constants/regEx';
import { globalPostService, globalPutService } from '../../../../utils/globalApiServices';
import { getEventListApi } from '../../../../shared_elements/actionCreators';
import { useSnackbar } from 'notistack';
import { setFileUploadDetails } from '../../../../shared_elements/actions';
import { trackActivity } from '../../../../utils/mixpanel';
import { formatBytes } from '../../../../utils/fileUpload';
import LessMoreTextFieldComp from '../../../../shared_elements/components/LessMoreTextFieldComp';

const EolObligationsCRU = ({ modeType, getResponseBack, fileUpload ,onToggleModal, addEditObligation, onOpenAttachments }) => {
    const dispatch = useDispatch()
    const { event,storageDetails } = useSelector((state) => state.leases);
      const { enqueueSnackbar } = useSnackbar();
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug };
    const [data, setData] = useState(addEditObligation?.data)
    const [isLoading, setLoading] = useState(false);
    const [isEventLoading,setEventLoading]=useState(!( event?.length > 0))
    const [error, setError] = useState({});
    const [attachments, setAttachments] = useState([]);

    const onRestErrorKey = (key) => {
        setError((prev) => ({ ...prev, [key]: '' }));
    };
    useEffect(() => {
        if (!event?.length) {
            dispatch(getEventListApi({ leaseSlug ,setEventLoading }, {'lite':'true'}));
        }
    }, [dispatch]);

    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value });
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    const handleFileChange = (files) => {
        setAttachments(files);
      dispatch(setFileUploadDetails({attachments:files}))
        
    };


    const onAddEditEolObligation = () => {
        const validationInputs = {
            event: data?.event ? "" : "Please select Event",
        };
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            if (data.id) {
                globalPutService(editEolObligationApi({ ...params, slug: data?.slug }), data).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(data?.slug,'updated')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" } });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit EOL Obligation`, success_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit EOL Obligation`, error_msg: response?.data?.message, item_id: data?.id, payload: data, response: response?.data })
                    }
                });
            } else {
                const { lessee, lessor, ...cleanedData } = data
                globalPostService(addEolObligationApi(params), { ...cleanedData, lessee_id: data?.lessee, lessor_id: data?.lessor }).then(async (response) => {
                    if (checkApiStatus(response)) {
                        if (attachments?.length) {
                            fileUpload(response?.data?.data?.slug,'created')
                        }
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Added', { page_title: `Add EOL Obligation`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: data, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Added', { page_title: `Add EOL Obligation`, error_msg: response?.data?.message, item_id: null, payload: data, response: response?.data })
                    }
                });
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} EOL Obligation`, error_msg: validationInputs, })
        }
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} EOL Obligation`, page_type: page_type, })
    }

    return (
        <>

            <Dialog
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        onToggleModal();
                    }
                }}
                aria-labelledby="customized-dialog-title"
                className='add-lease-dialog'
                maxWidth='md'
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography sx={{ marginLeft: '10px' }}>
                        {modeType === 'add' ? "Add EOL Obligation" : modeType === 'edit' ? 'Edit EOL Obligation' : 'View EOL Obligation '}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <Autocomplete
                                disablePortal
                                disableClearable
                                disabled={addEditObligation.mode === "view"}
                                options={event || []}
                                getOptionLabel={(option) => option?.name || ""}
                                noOptionsText={ isEventLoading && modeType !== "view" ? "Loading..." : "No Option Available" }
                                value={data?.event || null}
                                onChange={(e, value) => onFieldChange("event", value)}
                                onFocus={() => onRestErrorKey("event")}
                                renderInput={(params) => {
                                    const selectedLabel = params?.inputProps?.value || "";
                                    return (
                                        <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                            <TextField
                                                required
                                                {...params}
                                                label="Event"
                                                margin='normal'
                                                size='small'
                                                error={Boolean(error.event)}
                                                helperText={error.event}
                                                slotProps={{ inputLabel: { shrink: true, },
                                                    input: { ...params?.InputProps, endAdornment: ( <>{isEventLoading && modeType !== "view" && ( <CircularProgress color="inherit" size={20} /> )} {params?.InputProps?.endAdornment}</> ) }
                                                }}
                                            />
                                        </Tooltip>)
                                }}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                loading={modeType !== "view" && isEventLoading}
                                loadingText="Loading..."
                            />
                        </Grid>

                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                disabled={addEditObligation.mode === "view"}
                                label="Excess Refund"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                value={data?.excess_refund}
                                fullWidth
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("excess_refund", e.target.value.trimStart()) : e.preventDefault()}
                                onFocus={() => onRestErrorKey("excess_refund")}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 255} }}
                            />
                        </Grid>

                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                disabled={addEditObligation.mode === "view"}
                                label="Compensation Time"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                value={data?.compensation_time}
                                fullWidth
                                onChange={(e) => { const value = e.target.value; const isValidPercentage = regexConstants?.tsnRegex.test(value); if (value === '' || isValidPercentage) { onFieldChange("compensation_time", value); } }}
                                onFocus={() => onRestErrorKey("compensation_time")}
                                slotProps={{ inputLabel: { shrink: true } }}
                            />
                        </Grid>

                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                disabled={addEditObligation.mode === "view"}
                                label="Compensation Type"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                value={data?.compensation_type}
                                fullWidth
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("compensation_type", e.target.value.trimStart()) : e.preventDefault()}
                                onFocus={() => onRestErrorKey("compensation_type")}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 255} }}
                            />
                        </Grid>

                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                disabled={addEditObligation.mode === "view"}
                                label="Compensation Base"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                value={data?.compensation_base}
                                fullWidth
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("compensation_base", e.target.value.trimStart()) : e.preventDefault()}
                                onFocus={() => onRestErrorKey("compensation_base")}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: {maxLength: 255} }}
                            />
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Remarks' value={data?.remarks || ""} />
                        </Grid> :
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    disabled={addEditObligation.mode === "view"}
                                    label="Remarks"
                                    variant="outlined"
                                    size="small"
                                    margin="normal"
                                    fullWidth
                                    multiline
                                    value={data?.remarks ?? ""}
                                    rows={3}
                                    onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault() }}
                                    onFocus={() => onRestErrorKey("remarks")}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                />
                            </Grid>}

                        <Grid size={{ md: 12, xs: 12 }} sx={{mt: 3}}>
                            <Box className="responsive-buttons">
                            {data?.id && data?.attachments?.length ? (
                                <Button onClick={() => { onOpenAttachments(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>
                                    ({data?.attachments?.length})Attachment(s)
                                </Button>
                            ) : null}
                            <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                             </Box>
                            {modeType === "view" ? null : <AttachementsUpload onFileChange={handleFileChange} attachments={data?.attachments} remainingStorage={storageDetails?.remaining_storage} isNote={`'PRSV severity', 'PRSV severity table', 'de-rate', 'de-rate table', 'Lessor contribution language', 'Lease agreement'`} />}
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className='cancel-btn' disabled={isLoading} variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null :
                        <Button variant="contained" size="small" className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddEditEolObligation() }}> {isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>}
                </DialogActions>
            </Dialog>
        </>

    )
}
export default EolObligationsCRU;
